import { FEATURES } from '../appConstants';
import useFeatureFlags from './useFeatureFlags';

/**
 * Gates the Perx 3 redesign (light Intelligence Suite + Orbit). OFF must render the current dark UI
 * unchanged, so callers switch on the boolean rather than defaulting to the new variant.
 */
const usePerx3Redesign = (): boolean => useFeatureFlags()[FEATURES.PERX_3_REDESIGN.key] === true;

export default usePerx3Redesign;
